import { RightSideBarWrapper } from "../styles";

const RightSideBar = () => {
  return (
    <RightSideBarWrapper>
      <h3>summary</h3>
    </RightSideBarWrapper>
  );
};

export default RightSideBar;
